module.exports = __webpack_public_path__ + "static/hasan-9f058d9df836aea585000565d2fe5165.jpg";